// extracted by mini-css-extract-plugin
export default {"scanReceiptContainer":"scanReceiptContainer___g9tFQ","PDFViewer":"PDFViewer___NCCM4","pdfViewer":"PDFViewer___NCCM4"};